import Query from '../../components/Report';

const query = ({ offset = 0 }) => new Query('category-top-entities', { offset });

export default query;
